const priAge = ['៧០-៧១ខែ', '៦', '៧', '៨', '៩', '១០', '១១', '១២', '១៣', '១៤', '១៥+']
const priLevel = ['ថ្នាក់ទី ១', 'ថ្នាក់ទី ២', 'ថ្នាក់ទី ៣', 'ថ្នាក់ទី ៤', 'ថ្នាក់ទី ៥', 'ថ្នាក់ទី ៦', 'សរុបរួម (ពីថ្នាក់ទី ១ ដល់ទី ៦)']
const c2 = ['សិស្ស (អាយុ ៧០-៧១ខែ និង៦)', 'សិស្ស (អាយុ ៦-១១)', 'សិស្ស (អាយុ ១២+)', 'គ្រូបង្រៀន (ជនជាតិដើមភាគតិច)',
  'គ្រូមិនបង្រៀន (ជនជាតិដើមភាគតិច)']
const d2 = ['ចំនួនសិស្សដើមឆ្នាំសិក្សា', 'ចំនួនសិស្សចុងឆ្នាំសិក្សា', 'ចំនួនសិស្សត្រូវបានឡើងថ្នាក់', 'ចំនួនសិស្សត្រូវបានឆ្លងភូមិសិក្សា', 'សិស្សផ្ទេរមកពីសាលារៀនផ្សេង',
  'សិស្សផ្ទេរចេញទៅសាលារៀនផ្សេង']
const f2 = ['មត្តេយ្យរដ្ឋ', 'មត្តេយ្យឯកជន', 'មត្តេយ្យសហគមន៍', 'ការអប់រំតាមផ្ទះ/តាមខ្នងផ្ទះ', 'កម្មវិធីត្រៀមថ្នាក់ទី១']
const g2 = [{ value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.មួយវេន' },
{ value: 2, text: '២.ពីរវេន' }, { value: 3, text: '៣.បីវេន' }]
const lstStuOnOff = [
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
]
const ethpriOnOff = [
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
]
const stupriOnOff1 = [
  [1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
]
const stupriOnOff2 = [
  [0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0],
  [1, 1, 0, 0, 0, 0, 0, 0],
  [1, 1, 1, 1, 1, 1, 0, 0],
  [1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1]
]
const priStudentPublicOnOff = [
  [1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0],
  [1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
  [1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
]
/** Configuration of UI Page Text */
const priPriUIText = [
  ['១. អត្តសញ្ញាណ <p><br>និងព័ត៌មានសាវតា</p>', '១.(ក) នាយក/នាយិកាសាលាបឋមសិក្សា', '១.(ខ) សាលាបឋមសិក្សា'],
  ['២. សិស្ស', '<b>២.(ក)សិស្សថ្មី សិស្សឡើងថ្នាក់ និងសិស្សត្រួតថ្នាក់ ក្នុងឆ្នាំសិក្សា</b>',
    '២.(ខ)សិស្សថ្មីតាមអាយុ និងតាមកម្រិតថ្នាក់ដែលកំពុងរៀនសាលារដ្ឋ/សាលាផ្សេងទៀតក្នុងឆ្នាំសិក្សា',
    '២.(គ) សិស្សពិការ សិស្សជួបការលំបាកផ្នែកសុខភាព និងសិស្សជួបការលំបាកតាមកម្រិតថ្នាក់',
    '២.(ឃ) សិស្សតាមក្រុមអាយុ និងគ្រូ (ជនជាតិដើមភាគគិច)(ចំនួនសិស្សជនជាតិភាគតិច ក្នុងចំណោមសិស្សសរុបទាំងអស់)',
    '២.(ង)ចំនួនសិស្សក្នុងឆ្នាំសិក្សា ',
    '២.(ច)ចំនួនសិស្ស​ថ្មីថ្នាក់ទី១ឆ្លងកាត់កម្មវិធីអប់រំកុមារតូចគ្រប់រូបភាព(សិស្សម្នាក់អាចរាប់បានតែមួយដង)',
    '២.(ឆ)លទ្ធផលសិក្សា របស់សិស្សក្នុងឆ្នាំសិក្សា'
  ],
  ['៣. បន្ទប់រៀន និងថ្នាក់រៀន<p><br>និងកម្មវិធីសិក្សា</p>','៣.(ក) ចំនួនបន្ទប់រៀន', '៣.(ខ) ចំនួនថ្នាក់រៀន', '៣.(គ) កម្មវិធីសិក្សា'],
  ['៤.បុគ្គលិកបង្រៀន <p><br>និងបុគ្គលិកមិនបង្រៀន</p>', '៤.(ក)ចំនួនបុគ្គលិកគិតតាមក្រុមអាយុ(គិតដល់ថ្ងៃទី៣១-១២- ២០២០)',
    '៤.(ខ)ចំនួនបុគ្គលិកគិតតាមឆ្នាំបម្រើការងារអប់រំ', '៤.(គ)កម្រិតវប្បធម៌របស់បុគ្គលិក និងវគ្គបណ្ដុះបណ្ដាលគរុកោសល្យ', '៤.(ឃ)ចំនួនបុគ្គលិកបង្រៀន/មិនបង្រៀនទទួលមុខងារបន្ថែម'],
  ['៥. អគារ និងបរិក្ខារ', '៥.(ក) ផ្ទៃដីសាលារៀន', '៥.(ខ) អំពីសំណង់', '៥.(គ) ស្ថានភាពអគារ បន្ទប់ និងបរិក្ខារ',
    '៥(ឃ) ចំនួនបរិក្ខារ', '៥(ង).កន្លែងលាងដៃ', '៥.(ច)បង្គន់អនាម័យ (គិតជាបន្ទប់)', '៥.(ឆ).ប្រភពទឹកសម្រាប់ប្រើប្រាស់',
    '៥(ជ).សម្ភារបរិក្ខា', '៥.(ឈ) សម្ភារកីឡា'],
  ['៦.តម្លៃសិក្សាតាមកម្រិតថ្នាក់', '<strong>តម្លៃសិក្សាតាមកម្រិតថ្នាក់ (គិតក្នុង១ឆ្នាំសិក្សា)</strong>'],
  ['៧.ការចែកចាយថ្នាំព្រូនក្នុងឆ្នាំសិក្សា', '<strong>ការចែកចាយថ្នាំព្រូនក្នុងឆ្នាំសិក្សា</strong>']
]
export {
  priAge, priLevel, c2, d2, f2, g2,
  lstStuOnOff, ethpriOnOff,
  stupriOnOff1, stupriOnOff2,
  priStudentPublicOnOff,
  priPriUIText
}
